var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('default-header'),_c('v-main',[_vm._t("default")],2),_c('default-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }